<div class="table-row">
  <div class="table-item">{{ messageData.message }}</div>
  <div class="table-item">{{ message.created_at | lmsDate : group.timezone }}</div>
</div>
